document.addEventListener("turbolinks:load", function () {
  $("#loader").hide();
  $("#form-parts").submit(function () {
    $("#loader").show();
    $(window).on("load", function () {
      $("#loader").fadeOut("slow");
    });
  });
});
